export enum ActionStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Declined = 'Declined',
}
